export default class ApiBase {

	constructor () {
		this.data = null
		this.loading = false
		this.error = null
	}
}



// WEBPACK FOOTER //
// ./src/classes/api/ApiBase.js